var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "about-us" } },
    [
      _c(
        "b-container",
        [
          _c("h1", [
            _vm._v("ePictureMounts - Specialists in Picture & Photo Mounts"),
          ]),
          _c(
            "b-row",
            { staticClass: "py-4", attrs: { "align-v": "center" } },
            [
              _c("b-col", [
                _c("p", { staticClass: "lead" }, [
                  _vm._v(
                    "At ePictureMounts we are your one-stop shop for high quality Picture & Photo Mounts. We are a Fine Art Trade Guild commended picture framers in Chesterfield, Derbyshire who specialise in supplying bespoke and standard sized picture mounts to the UK and Worldwide."
                  ),
                ]),
              ]),
              _c("b-col", { attrs: { lg: "6" } }, [
                _c(
                  "figure",
                  { staticClass: "figure" },
                  [
                    _c("b-img", {
                      attrs: {
                        fluid: "",
                        rounded: "",
                        src: "https://static.bramptonframing.com/img/site/team-photo.webp",
                        alt: "ePictureMounts Team - Specialists in Photo & Picture Mounts",
                      },
                    }),
                    _c("figcaption", { staticClass: "figure-caption" }, [
                      _vm._v("The team at ePictureMounts."),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-container",
        { staticClass: "bg-light py-4", attrs: { fluid: "" } },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "6", "order-lg": "1", order: "2" } },
                    [
                      _c("iframe", {
                        staticStyle: {
                          width: "100%",
                          height: "650px",
                          border: "0",
                          "margin-bottom": "-5px",
                          "border-radius": "5px",
                        },
                        attrs: {
                          src: "https://www.google.com/maps/embed/v1/place?q=Brampton%20Picture%20Framing%2C%20Old%20Hall%20Road%2C%20Chesterfield%2C%20United%20Kingdom&key=AIzaSyD1NsOBB-qeIWdX8bFLaBQpvxOfWQNJgPM&zoom=19&maptype=satellite",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "b-col",
                    { attrs: { lg: "6", "order-lg": "2", order: "1" } },
                    [
                      _c("p", { staticClass: "lead" }, [
                        _vm._v(
                          "Our workshop is located close to the M1, just 15 minutes drive from Junction 29."
                        ),
                      ]),
                      _c("p", { staticClass: "lead" }, [
                        _vm._v(
                          "Our customers travel from all over the country for our specialist picture framing services and huge choice of picture frames and mounts."
                        ),
                      ]),
                      _c("p", { staticClass: "lead" }, [
                        _vm._v(
                          "We have 2 Fine Art Trade Guild commended picture framers with over 30 years experience between them."
                        ),
                      ]),
                      _c("p", { staticClass: "lead" }, [
                        _vm._v(
                          "We don't only sell picture mounts, we sell all things picture framing related from bespoke sized picture frames to accessories such as specialist framing tape.If you would like to see our full range of products please visit "
                        ),
                        _c(
                          "a",
                          {
                            attrs: { href: "https://www.bramptonframing.com" },
                          },
                          [_vm._v("bramptonframing.com")]
                        ),
                        _vm._v("."),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-container", { staticClass: "py-4" }, [
        _c("h3", { staticClass: "text-center" }, [_vm._v("Contact Us")]),
        _c("p", { staticClass: "text-center" }, [
          _vm._v(
            "Please contact us if you have any questions or enquiries using our details below:"
          ),
        ]),
        _c("p", { staticClass: "lead text-center" }, [
          _c("span", { staticClass: "material-icons mr-2 md" }, [
            _vm._v("phone"),
          ]),
          _c("a", { attrs: { href: "tel:01246554338" } }, [
            _vm._v("01246 554338"),
          ]),
        ]),
        _c("p", { staticClass: "lead text-center mb-0" }, [
          _c("span", { staticClass: "material-icons mr-2 md" }, [
            _vm._v("email"),
          ]),
          _c("a", { attrs: { href: "mailto:sales@epicturemounts.co.uk" } }, [
            _vm._v("sales@epicturemounts.co.uk"),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }